import React, { useState } from "react";
import { TableContainer, Paper, Typography, Box } from "@mui/material";
import NoDataFound from "../../Components/Masters/NoDataFound";
import PaginationBox from "../../Components/Masters/Pagination";
import { getMonthName } from "../../utils/getMonthName";
import DocFiles from "./DocFiles";
import { fixedPercentage } from "../../utils/common";
import DocumentItem from "../../Components/Masters/DocumentItem";

function TableDocument({
  data,
  totalPages,
  headers,
  page = 1,
  handleChangePage,
  columnWidth,
  tableContainerRef,
  isShortContent,
}) {
  const [openDoc, setOpenDoc] = useState({});

  const handleChangeView = (data) => {
    setOpenDoc((prevState) => ({
      ...prevState,
      [data._id]: !prevState[data._id], // Toggle visibility for the clicked row based on _id
    }));
  };

  return (
    <Box>
      <TableContainer
        component={Paper}
        ref={tableContainerRef}
        sx={{ maxWidth: "100%" }}
      >
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: columnWidth,
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {headers.map((el) => (
              <Typography
                key={el?.key ?? el?.title}
                sx={{
                  height: "100%",
                  fontWeight: "bold",
                  padding: "8px 12px",
                  paddingY: "10px",
                  textAlign: el?.title === "Date" ? "center" : "left",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {el?.title}
              </Typography>
            ))}
            <Typography
              sx={{
                fontWeight: "bold",
                padding: "8px 12px",
                paddingY: "10px",
                textAlign: "center",
              }}
            >
              Documents
            </Typography>
          </Box>
          {data.length === 0 ? (
            <NoDataFound />
          ) : (
            data?.map((item) => (
              <Box
                key={item._id}
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  borderBottom: "1px solid #ddd",
                }}
              >
                {headers.map((el) => (
                  <Typography
                    key={`${item._id}-${el?.key ?? el?.title}`}
                    sx={{
                      textAlign: "left",
                      ...(el?.key === "reportingPeriod"
                        ? {
                            whiteSpace: "normal",
                            overflow: "visible",
                            wordBreak: "break-word",
                          }
                        : {
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }),
                      fontSize: "14px",
                      color: "black",
                      padding: "8px 12px",
                      paddingTop: "1rem",
                    }}
                  >
                    {
                      el?.key === "createdAt" || el?.key === "dateOfTravel" || el?.key === "dateOfSale" || el?.key === "purchaseDate"
                        ? new Date(item[el?.key]).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        : el?.key === "consumptionPeriod"
                          ? getMonthName(item[el?.key]?.month) +
                          ", " +
                          item[el?.key]?.year
                          : el?.key === "efficiency"
                            ? fixedPercentage(item[el?.key])
                            : el?.key === "equipment"
                              ? item[el?.key]?.equipment
                              : el.key === "vendor"
                                ? item[el.key]?.VendorLegalFullName
                                : el.key === "quantityConsumed"
                                  ? item[el.key].value + " " + item[el.key].unit
                                  : el.key === "unitOfProductSold"
                                    ? (() => {
                                      const u = item[el.key];
                                      if (u && typeof u === "object") {
                                        const qty =
                                          u.value !== undefined && u.value !== null
                                            ? u.value
                                            : "";
                                        const unit = u.unit || "";
                                        const combined = `${qty} ${unit}`.trim();
                                        return combined || "N/A";
                                      }
                                      return u || "N/A";
                                    })()
                                    : el.key === "quantityOfWasteGenerated"
                                      ? item[el.key].value + " " + item[el.key].unit
                                      : el.key === "purchases"
                                        ? item[el.key].vendorLegalName
                                        : el.key === "quantityOfWasteManaged"
                                          ? item[el.key].value + " " + item[el.key].unit
                                          : el.key === "projectLocation"
                                            ? item[el.key].city +
                                            ", " +
                                            item[el.key].state +
                                            ", " +
                                            item[el.key].country
                                            : typeof item[el.key] === "object" &&
                                              item[el.key][el.field] !== null &&
                                              item[el.key][el.field]
                                              ? item[el.key][el.field]
                                              : typeof item[el.key] === "object" &&
                                                item[el.key] !== null &&
                                                item[el.key].name
                                                ? item[el.key].name
                                                : item[el.key] !== undefined &&
                                                    item[el.key] !== null &&
                                                    item[el.key] !== ""
                                                  ? item[el.key]
                                                  : "N/A"
                    }
                  </Typography>
                ))}
                <Typography
                  sx={{
                    padding: "8px 12px",
                    paddingTop: "1rem",
                    color: openDoc[item._id] ? "#FF282C" : "#004DAF",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontStyle: "Inter",
                    textAlign: "center",
                  }}
                  onClick={() => handleChangeView(item)}
                >
                  {openDoc[item._id] ? "Close" : "View"}
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    padding: "8px 12px",
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "1rem",
                  }}
                >
                  {openDoc[item._id] && item?.documents?.length > 0 && (
                    <>
                      {item.documents.map((url, index) => (
                        // <DocFiles key={`file-${index}`} url={url} />
                        <DocumentItem key={`file-${index}`} url={url} />
                      ))}
                    </>
                  )}
                </Box>
              </Box>
            ))
          )}
        </Box>
      </TableContainer>
      {/* Pagination */}
      {totalPages > 1 && (
        <PaginationBox
          isShortContent={isShortContent}
          {...{
            totalPages,
            page,
            handleChangePage,
          }}
        />
      )}
    </Box>
  );
}

export default TableDocument;
